import http from "../../http-common";

class service {

  url = "/lingua/lingua";

  getAll() {
    return http.get(this.url);
  }

  get(id, params = {}) {
    return http.get(this.url + '/' + id, { params });
  }

  search(params) {
    return http.get(this.url + '/search', { params });
  }
}

export default new service();